if (!customElements.get('sg-pack-slider')) {
  customElements.define('sg-pack-slider', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const start = () => {
        if (this.viewport || !this.isConnected) return;
        const viewport = this.querySelector('.sg-pack-grid');
        this.viewport = viewport;
        const prev = this.querySelector('[data-pack-prev]');
        const next = this.querySelector('[data-pack-next]');
        const on = (el, name, fn) => el.addEventListener(name, fn, {signal:this.abort.signal});
        const update = () => {
          prev.disabled = viewport.scrollLeft <= 2;
          next.disabled = viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 2;
        };
        const step = sign => viewport.scrollBy({left:sign*(viewport.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(viewport).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        on(prev,'click',()=>step(-1));on(next,'click',()=>step(1));
        on(viewport,'scroll',update);
        on(viewport,'keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();step(e.key==='ArrowLeft'?-1:1);}});
        on(viewport,'pointerdown',e=>{
          if(e.pointerType!=='mouse'||e.button!==0)return;
          this.drag={x:e.clientX,left:viewport.scrollLeft};
          viewport.classList.add('is-dragging');viewport.setPointerCapture(e.pointerId);
        });
        on(viewport,'pointermove',e=>{if(this.drag)viewport.scrollLeft=this.drag.left+this.drag.x-e.clientX;});
        const release=()=>{this.drag=null;viewport.classList.remove('is-dragging');};
        on(viewport,'pointerup',release);on(viewport,'pointercancel',release);on(viewport,'lostpointercapture',release);
        this.resize=new ResizeObserver(update);this.resize.observe(viewport);update();
      };
      if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true,signal:this.abort.signal});else start();
    }
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.viewport=null;this.drag=null;}
  });
}
